<template>
    <div style="padding: 20px">
        <div class="two-column-section">
            <section>
                <div class="container">
                    <div class="row">
                        <div class="text-container" id="main-content">
                            <h2>Om Museernes Samlinger</h2>
                            <p>
                                På hjemmesiden Museernes Samlinger kan offentligheden danne sig et overblik over de
                                danske statslige og statsanerkendte museers samlinger.
                            </p>

                            <p>
                                I Danmark har de statslige og statsanerkendte museer deres samlinger i et samlet system
                                kaldet SARA. Når museerne opdaterer SARA med nye genstande eller informationer, vil man
                                kunne se det i Museernes Samlinger.
                            </p>

                            <p>
                                Gå på opdagelse i Museernes Samlinger ved hjælp af søgefunktionen, eller læs mere om
                                søgemulighederne.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <section class="faq-section" id="faq">
            <div class="accordion">
                <div class="accordion-item scroll-target" :id="item.id" v-for="(item, index) in faqItems" :key="index">
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button"
                            @click="toggleAccordion(index)"
                            :aria-expanded="activeIndex === index"
                            :aria-controls="'faq-content-' + index"
                            :id="'faq-header-' + index"
                        >
                            <span>{{ item.question }}</span>
                            <span class="accordion-icon">
                                <i
                                    class="fas"
                                    :class="activeIndex === index ? 'fa-circle-chevron-up' : 'fa-circle-chevron-down'"
                                ></i>
                            </span>
                        </button>
                    </h2>

                    <div
                        class="accordion-content"
                        v-if="activeIndex === index"
                        :id="'faq-content-' + index"
                        role="region"
                        :aria-labelledby="'faq-header-' + index"
                    >
                        <p v-html="item.answer"></p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "about-page",
    data() {
        return {
            contentRefs: [],
            activeIndex: null,
            contentHeights: [],
            faqItems: [
                {
                    question: "HVOR KOMMER DATA FRA?",
                    answer: `De statslige og statsanerkendte museer er forpligtede til at indberette deres samlinger til et nationalt register kaldet SARA. Når museerne opdaterer SARA med nye genstande, billeder eller informationer, vil man efter cirka en time kunne se ændringerne i Museernes Samlinger.<br><br>
                    Der kan være genstande og værker i museernes samlinger, som ikke fremgår af denne hjemmeside. Museerne kan fravælge offentlig visning i tilfælde, hvor hensynet til fx personfølsomme oplysninger taler derfor.
                    `,
                    id: "hvor_kommer_data_fra",
                },
                {
                    question: "SØGNING I MUSEERNES SAMLINGER",
                    answer: `
                    For at få mest muligt ud af Museernes Samlinger kan du her få nogle tips til, hvordan du styrker din søgning.<br><br>
                    Fritekstsøgning på Museernes Samlingers forside bruges på samme måde, som du kender det fra standardsøgemaskiner (Google, Bing, etc.). Du kan indtaste hele eller delvise ord, flere ord og sågar anvende søgekommandoer. Sidstnævnte er det kun de færreste, der anvender i dagligdagen, men netop søgekommandoerne kan være ekstra anvendelige på Museernes Samlinger.<br><br>
                    For at du får mest ud af dine søgninger, gennemgår vi de mest anvendelige søgefunktioner nedenfor.<br><br>

                    <strong>Et ord</strong><br>
                    Søger du for eksempel på ordet [Hasle], så søger du på ord, der starter med Hasle, men får også søgeresultater for eksempel Hasles, Haslev, og så videre.<br><br>

                    <strong>Flere ord</strong><br>
                    Søger du for eksempel på ordene [Hasle] og [fisk] returneres ord, der starter med begge søgekriterier – altså, Hasle, Haslev, fisk, fiskeri, og så videre. Søger du på flere ord, foretager du altså en ”eller”-søgning (det ene, eller det andet ord). Det letteste er at indsætte et mellemrum mellem ordene, men du kan også anvende, et plus (+), eller ampersand (&) mellem ordene.<br><br>

                    <strong>Eksakt søgning</strong><br>
                    Ønsker du at søge på flere eksakte ord, skal du anvende citationstegn (” ”). Altså, [”Hasle røgeri”], så du for eksempel undgår andre røgerier i dit resultatsæt.<br><br>

                    <strong>Bogstavkombination</strong><br>
                    Søger du ikke på ord, men på en række bogstaver, der kan optræde inde i et ord, så kan du anvende en såkaldt ”wildcard”-søgning ved at anvende en asterisk (*). Det kunne være [*asle], der vil returnere alle ord, der ender på asle (fx Hasle), eller [*asle*], der vil returnere alle ord der indeholder asle (fx Haslev).<br><br>

                    Husk, at alle fritekstsøgninger kan kombineres med filtrene.
                `,
                    id: "sogning_i_museernes_samlinger",
                },
                {
                    question: "BRUG AF BILLEDER OG DATA",
                    answer: `Museerne er ansvarlige for billeder og data, der vises i Museernes Samlinger. For at sikre at du har ret til at anvende billeder og data fra Museernes Samlinger, bør du derfor først kontrollere den angivne copyrightkreditering, der vises på hver genstands- og værkside.<br><br>
                    
                    Læg mærke til at undervisningsinstitutioner med en VISDA-licens frit kan bruge alle billeder fra Museernes Samlinger i undervisningssammenhæng.<br><br>

                    Slots- og Kulturstyrelsen kan ikke rådgive om VISDA’s licens men henviser i stedet til <a href="https://www.visda.dk/bruger-du-billeder/undervisning/" target="_blank">VISDA</a>. `,
                    id: "brug_af_billeder_og_data",
                },
                {
                    question: "SPØRGSMÅL ELLER FEEDBACK TIL INDHOLDET",
                    answer: `<p>Hvis du har spørgsmål til en genstand eller værk, eller yderligere oplysninger som du gerne vil bidrage med, skal du henvende dig til det museum, der er oplyst som ansvarlig for genstanden/værket.</p>
                    <p>Find det enkelte museums kontaktoplysninger på museets egen hjemmeside.</p>`,
                    id: "sporgsmal_eller_feedback_til_indholdet",
                },
                {
                    question: "SPØRGSMÅL ELLER FEEDBACK TIL DRIFTEN AF MUSEERNES SAMLINGER",
                    answer: `Slots- og Kulturstyrelsen driver og udvikler Museernes Samlinger. Har du spørgsmål til selve driften af hjemmesiden, kan du skrive til <a href="mailto:sara@slks.dk">sara@slks.dk</a>`,
                    id: "sporgsmal_eller_feedback_til_driften_af_museernes_samlinger",
                },
            ],
        };
    },
    watch: {
        $route(to) {
            this.handleHashChange(to.hash);
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.openAccordionFromHash();
        });

        window.addEventListener("hashchange", this.openAccordionFromHash);
    },
    beforeUnmount() {
        window.removeEventListener("hashchange", this.openAccordionFromHash);
    },
    methods: {
        toggleAccordion(index) {
            this.activeIndex = this.activeIndex === index ? null : index;
        },
        setContentHeights() {
            this.contentHeights = Array.from(this.$refs.contentRefs).map((ref) => ref.scrollHeight);
        },
        handleHashChange(hash = this.$route.hash) {
            if (hash) {
                const cleanHash = decodeURIComponent(hash.replace("#", "")).toLowerCase();
                const index = this.faqItems.findIndex((item) => item.id === cleanHash);
                if (index !== -1) {
                    this.toggleAccordion(index);
                    document.getElementById(this.faqItems[index].id).scrollIntoView();
                }
            }
        },

        openAccordionFromHash() {
            const hash = window.location.hash.replace("#", "");
            //let element = false;
            this.faqItems.map((el, index) => {
                if (el.id == hash) {
                    element = true;
                    this.activeIndex = index;
                    document.getElementById(hash).scrollIntoView();
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/colors.scss";
@import "@/styles/mixins.scss";

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
}

h2 {
    font-size: 2.5em;
    color: white;
    margin-bottom: 15px;
    line-height: 1.3;
}

p {
    margin-bottom: 1rem;
}

.two-column-section {
    margin-top: 130px;
    padding: 2rem 0;
}

.row {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    justify-content: center;
}

.text-container {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    text-align: left;
}

.image-container img {
    max-width: 100%;
}

.faq-section {
    padding: 2rem 20px;
}

.accordion {
    background-color: $slks-dark-search-bg;
    color: white;
    // padding: 20px;
    max-width: 800px;
    margin: 0 auto;
    box-sizing: border-box;
}

.accordion-item {
    margin-bottom: 1rem;
}

.accordion-button {
    background: $slks-dark-filter-text; //$slks-dark-filter-bg;
    border: none;
    width: 100%;
    text-align: left;
    padding: 1rem;
    font-size: 1rem;
    color: #000;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background 0.3s ease;
}

.accordion-button:hover {
    // $slks-dark-search-input-border: #9d9d9d;
    background: $slks-dark-search-input-border// #3c3c3c;
}

// .accordion-button:hover .accordion-icon {
//     color: #ddd;
// }

.accordion-content {
    overflow: hidden;
    transition: max-height 0.3s ease;
    padding: 0 1rem;
    margin-bottom: 10px;
    color: #000;
    background: $slks-dark-filter-text;
    // border: 2px solid $slks-dark-filter-bg;//$slks-dark-primary-bg;
    // border-radius: 5px;
}

.accordion-content p {
    margin: 0;
    padding: 10px 0;
}

.accordion-icon {
    font-size: 1.2rem;
    color: black;
    transition: transform 0.3s ease;
    padding: 0 5px;
}

::v-deep(.accordion-content p strong) {
    color: #000 !important;
}

@media (max-width: 1024px) {
    .two-column-section {
        margin-top: 65px;
    }
}

@media (max-width: 768px) {
    .row {
        flex-direction: column;
    }

    .image-container,
    .text-container {
        width: 100%;
    }
}
.scroll-target {
    scroll-margin-top: 100px;
}
.accordion-header {
    margin: 0; // Remove default margins from h2
    padding: 0;
}

.accordion-header button {
    width: 100%;
    text-align: left;
    background: $slks-dark-filter-text;
    border: none;
    padding: 1rem;
    font-size: 1rem;
    color: #000;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background 0.3s ease;
}

.accordion-header button:hover {
    background: $slks-dark-search-input-border;
}
</style>
